import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable, Observer, Subject, of} from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class NewsfeedService {

  constructor(private http: Http, private _utilsService: UtilsService) { }

  getPosts(user_id, filters, page=1, search='', save=false, lgId, tourId, pageName) {
    if (pageName == 'lgProfile') {
      return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user_posts/get-league-post/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + parseInt(lgId) + '/' + user_id + '/' + parseInt(tourId) + '/' + page);
    }
    else {
      const filter_data = {
        feedtext_search:search,
        feed_type:filters.feed_type.split(','),
        apply_lobby_filter:(save)?1:0,
        game_type:filters.game_type.split(',')
      };
  
      filters.news_priority.split(',').forEach(game => {
        const data = game.split('|');
        if (data.length == 2) filter_data['priority_' + data[0]] = parseInt(data[1]);
      });
  
      var data = {
        access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
        user_uuid: parseInt(user_id),
        page_no: page,
        filter_data,
        league_id: parseInt(lgId),
        tournament_id: parseInt(tourId)
      };
      
      return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/filter_app', data, null, 'content-type-json'); 
    }
  }

  likePost(user_uuid, post_uuid, posted_by_uuid, like_status, display_name) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid,
      post_uuid,
      posted_by_uuid,
      like_status,
      display_name
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/like-dislike', data, null, 'content-type-json');
  }

  likeComment(user_uuid, post_uuid, like_status, display_name) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid,
      post_uuid,
      like_status,
      display_name
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/like-dislike-comment', data, null, 'content-type-json');
  }

  loadMoreComments(post_id, cursor, user_id, totalComment) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      post_id,
      cursor,
      user_id,
      lastCommentId:0,
      totalComment
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/load_more_comment', data, null, 'content-type-json');
  }

  getPoll(poll_id, user_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/feed/getPoll/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + poll_id + '/' + user_id);
  }

  getPollVoters(poll_id, choice) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/feed/getPollVoters/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + poll_id + '/' + choice);
  }

  votePoll(poll_id, user_id, choice) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/feed/votePoll/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + poll_id + '/' + user_id + '/' + choice);
  }

  createPoll(user_id, question, options) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_id,
      question,
      options
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/feed/createPoll', data, null, 'content-type-json');
  }

  makePost(user_uuid, status_detail, post_type, user_display_name, push_notification=null, fantasy_league_id=null, tournament_id=null, summary=null, league_name=null, league_type=null, parent_post_id=null, info=null, content=null, privacy=null, image=null) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid,
      status_detail,
      post_type,
      user_display_name,
      fantasy_league_id: (fantasy_league_id) ? parseInt(fantasy_league_id) : null,
      tournament_id: (tournament_id) ? parseInt(tournament_id) : null,
      summary,
      league_name,
      league_type,
      parent_post_id,
      info,
      content,
      privacy,
      image,
      push_notification
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/addnewpost', data, null, 'content-type-json');
  }

  makeComment(user_uuid, post_uuid, display_name, comment) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid,
      post_uuid,
      display_name,
      comment
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/add-comment', data, null, 'content-type-json');
  }

  searchGiphy(search, offset, limit) {
    const key = 'nk28OLJ1XsDBaCt8CsKILEikos7zQt9g';
    const url = 'https://api.giphy.com/v1/gifs/search?api_key='+key+'&q='+encodeURIComponent(search)+'&limit='+limit+'&offset='+offset;
    return this.http
      .get(url,{})
      .pipe(map(res => res.json()
      )
    );
  }

  postLikeList(post_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}`+'/user_posts/user_like_list/'+`${environment.DRAFT_ACCESS_TOKEN}`+'/like/'+post_id);
  }

  commentLikeList(comment_id) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}`+'/user_posts/comment_like_list/'+`${environment.DRAFT_ACCESS_TOKEN}`+'/like/'+comment_id);
  }

  pollLikeList(poll_id, choice) {
    return this._utilsService.getRequest(`${environment.phpApiUrl}`+'/feed/getPollVoters/'+`${environment.DRAFT_ACCESS_TOKEN}`+'/'+poll_id+'/'+choice);
  }
  
  deletePost(user_uuid, post_uuid, role_type) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid, 
      post_uuid,
      role_type
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/delete-post', data, null, 'content-type-json');
  }
  
  hidePost(user_uuid, post_uuid) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid, 
      post_uuid
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/hide-post', data, null, 'content-type-json');
  }
  
  pinPost(role_type, post_uuid, status) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      role_type, 
      post_uuid,
      status
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/pin-post', data, null, 'content-type-json');
  }
  
  deleteComment(user_uuid, comment_id, role_type) {
    var data = {
      access_token: `${environment.DRAFT_ACCESS_TOKEN}`,
      user_uuid, 
      comment_id,
      role_type
    };
    return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user_posts/delete-comment', data, null, 'content-type-json');
  }
}